ready(() => {

    const viewCart = document.querySelector("#uc-cart-view-form");
    if (viewCart) {
        const formActions = viewCart.querySelector(".form-actions");
        formActions.append(createElement('a', ['btn', 'btn-secondary', 'btn-print'], {
            href: "javascript://",
            textContent: "Распечатать сведения о заказе!",
        }));
        viewCart.querySelectorAll("input.form-submit[name^='remove']").forEach((elem) => {
            elem.parentElement.append(createElement('div', ['field', 'field-type-custom', 'field-remove', 'field-label-hidden']));
            const fieldRemove = elem.parentElement.querySelector(".field-remove");
            fieldRemove.append(createElement('div', ['value']));
            const value = fieldRemove.querySelector(".value");
            value.append(elem.parentElement.querySelector("input.form-submit[name^='remove']"));
        });
    }

    const checkoutForm = document.querySelector("#uc-cart-checkout-form");
    if (checkoutForm) {
        const checkoutFormActions = checkoutForm.querySelector(".form-actions");

        checkoutForm.append(createElement('h3', ['uc-cart-checkout-form__title'], {
            textContent: "Укажите ваши контактные данные!",
        }));
        checkoutForm.append(createElement('p', ['uc-cart-checkout-form__markup'], {
            textContent: "После оформления заказа мы свяжемся с вами и уточним информацию по доставке и оплате",
        }));
        checkoutForm.append(createElement('div', ['uc-cart-checkout-form__privacy-policy'], {
            textContent: "Отправляя форму вы даете согласие на обработку персональных данных",
        }));
        checkoutFormActions.append(createElement('a', ['btn', 'btn-in-cart'], {
            href: "/cart",
            textContent: "В корзину",
        }));

        const checkoutFormDetail = document.querySelector(".cart-review");
        if (checkoutFormDetail) {
            const checkoutFormDetailBody = checkoutFormDetail.querySelector("tbody");
            const checkoutFormDetailFoot = checkoutFormDetail.querySelector("tfoot");
            const tr = createElement('tr');
            const td = createElement('td');
            tr.append(td);
            checkoutFormDetailFoot.append(tr);
            checkoutFormDetailFoot.querySelector("tr:last-child td").append(createElement('a', ['btn', 'btn-secondary'], {
                href: "javascript://",
                textContent: "Посмотреть заказ",
            }));
            checkoutFormDetailFoot.querySelector(".btn").addEventListener("click", e => {
                e.preventDefault();
                if (checkoutFormDetailBody.classList.contains("is-open")) {
                    checkoutFormDetailBody.classList.remove("is-open");
                    e.currentTarget.textContent = "Посмотреть заказ";
                } else {
                    checkoutFormDetailBody.classList.add("is-open");
                    e.currentTarget.textContent = "Свернуть заказ";
                }
            });
        }

    }

    const checkoutReviewForm = document.querySelector("#uc-cart-checkout-review-form");
    if (checkoutReviewForm) {
        checkoutReviewForm.querySelector(".form-actions #edit-back").remove();
        checkoutReviewForm.querySelector(".form-actions").prepend(createElement('a', ['btn', 'btn-in-cart'], {
            href: "/cart/checkout",
            textContent: "Назад",
        }));
    }

});